import React from "react";
import { RiShareBoxFill, RiGitBranchLine } from "react-icons/ri";
import { formatDate, toCamelCase } from "../../utils/units";
import DeploymentLogs from "../DeploymentLogs";

const ProjectInfoCard = ({
  project,
  projectUrl,
  imgLoading,
  cachedImage,
  status,
  isViewOnly,
  onToggleStatus,
  statusLoading,
}) => {
  return (
    <div className="details-card">
      <div className="details-card-body">
        <div className="row">
          {/* Screenshot */}
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="ratio ratio-16x9 rounded-3 overflow-hidden bg-light border">
              {!imgLoading ? (
                cachedImage ? (
                  <img
                    src={cachedImage}
                    alt={project.projectName}
                    className="img-fluid object-fit-cover h-100 w-100"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/404.svg";
                    }}
                  />
                ) : (
                  <img
                    src="/404.svg"
                    alt="No Screenshot"
                    className="img-fluid object-fit-cover h-100 w-100"
                  />
                )
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div className="spinner-border text-secondary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Info Details */}
          <div className="col-md-8">
            <div className="row g-4">
              <div className="col-md-6">
                <div className="info-label">Domain</div>
                <div className="info-value">
                  <a
                    href={projectUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-primary d-flex align-items-center gap-2"
                  >
                    {project.domain} <RiShareBoxFill />
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-label">Live Health Check</div>
                <div className="info-value">
                  {status ? (
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className={`status-dot ${status.isHealthy ? "live" : status.status === "live" ? "warning" : "offline"}`}
                      ></span>
                      <span>{toCamelCase(status.status)}</span>
                      {status.responseTime && (
                        <span className="text-muted fs-7">
                          ({status.responseTime}ms)
                        </span>
                      )}
                      <span className="text-muted fs-7">
                        · {formatDate(status.timestamp, "time")}
                      </span>
                    </div>
                  ) : (
                    <span className="text-muted">Checking...</span>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-label">Created On</div>
                <div className="info-value">
                  {formatDate(project.createdAt, "day-shortMonth-year")}
                </div>

                {!isViewOnly && (
                  <button
                    type="button"
                    className={`btn btn-sm project-status-toggle ${
                      project.status === "active" ? "btn-danger" : "btn-success"
                    }`}
                    onClick={onToggleStatus}
                    disabled={statusLoading}
                  >
                    {project.status === "active" ? "Deactivate" : "Activate"}
                  </button>
                )}
              </div>
              {project.githubRepo && !isViewOnly && (
                <div className="col-md-6">
                  <div className="info-label">GitHub Repository</div>
                  <div className="info-value">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <RiGitBranchLine />{" "}
                      {project?.githubData?.branch || "main"}
                    </div>
                    <a
                      href={project.githubRepo}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-primary fs-7"
                    >
                      View Repo <RiShareBoxFill />
                    </a>
                  </div>
                </div>
              )}
            </div>

            <hr className="my-4" />

            <div className="accordion" id="logsAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingLogs">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseLogs"
                  >
                    <i className="bi bi-terminal me-2"></i> Deployment Logs
                  </button>
                </h2>
                <div
                  id="collapseLogs"
                  className="accordion-collapse collapse"
                  data-bs-parent="#logsAccordion"
                >
                  <div className="accordion-body">
                    <DeploymentLogs domain={project.domain} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectInfoCard;
